import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { shallowEqual, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useSubheader } from '../../../_metronic/layout';
import { confirmCheckoutSession } from '../../../stripe';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
  box: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  spinner: {
    marginTop: '2rem',
  },
}));

export function OnDemandPaymentsSuccessPage() {
  const classes = useStyles();
  const location = useLocation();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const subheader = useSubheader();
  subheader.setTitle('On-demand payments');

  const [confirming, setConfirming] = useState(true);
  const [error, setError] = useState(null);
  const [paid, setPaid] = useState(false);
  const [session, setSession] = useState(null);
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setSession(searchParams.get('session'));
  }, [location.search]);

  useEffect(() => {
    async function confirm() {
      try {
        if (session) {
          const response = await confirmCheckoutSession({
            session,
            type: 'on-demand-payment',
            user,
          });

          setPaid(response.payment_status === 'paid');
          setPayment(response.metadata.onDemandPaymentNumber);
        }
      } catch (e) {
        setError(e);
      } finally {
        setConfirming(false);
      }
    }

    setConfirming(true);
    void confirm();
  }, [session, user]);

  function renderMessages() {
    if (confirming) {
      return <>
        <div className="dci-title">Confirming payment, please hold!</div>
        <span className={`spinner spinner-darker-info spinner-lg ${classes.spinner}`} />
      </>;
    }

    if (paid) {
      return <>
        <div className="dci-title">Payment #{payment} confirmed!</div>
      </>;
    }

    if (error) {
      return <>
        <div className="dci-title">Payment could not be confirmed.</div>
        <span>Error: {error.message}</span>
      </>;
    }

    return <>
      <div className="dci-title">Payment #{payment} is not confirmed yet.</div>
    </>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.box}>
        {renderMessages()}
      </div>
    </div>
  );
}
